import Vue from "vue";

export const CreateCloserEventBus = new Vue();
